<template>
     <el-tree-select class="filterItem-value"
        v-model="filterItem.value" 
        :data="deaprtOptions" 
        clearable
        multiple
        collapse-tags
        collapse-tags-tooltip
        show-checkbox 
        check-strictly>
    </el-tree-select>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import Tree from '@/components/Tree/Tree.vue'
    import { listToTree } from "@/common/commonHelper"
    import { getDepart } from "@/apis/httpHelper"

    export default {
        name:"DepartFieldFilter",
        mixins:[baseFilter],
        components:{
            'tree':Tree
        },
        created:function(){
            getDepart().then(x=>{
                this.departList = x.Result;
                this.deaprtOptions = listToTree(x.Result).map(x=> this.mapToElTree(x));
            }).catch(x=>{
                console.log(x);
            });
        },
        data:function(){
            return {
                deaprtOptions:[],
                departList:[]
            }
        },
        computed:{
            selectDepartInfo:function(){
                return this.departList.filter(x=> (this.filterItem.value || []).includes(x.Id));
            }
        },
        methods:{
            mapToElTree:function(tree){
                let result = {};
                result.value = tree.Id;
                result.label = tree.Name;
                if(tree.Children.length > 0){
                    result.children = tree.Children.map(x=> this.mapToElTree(x))
                }
                return result;
            }
        }
    }
</script>